import { FareFamily } from '@fcom/dapi/api/models/fare-family';
import { FareInformation } from '@fcom/dapi/api/models/fare-information';
import { FinnairBoundFareFamily } from '@fcom/dapi/api/models/finnair-bound-fare-family';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { FinnairTravelEndpoint } from '@fcom/dapi/api/models/finnair-travel-endpoint';

export interface FinnairTravelLocation extends FinnairTravelEndpoint {
  cityName?: string;
  name?: string;
  countryCode?: string;
}

export interface FinnairBoundItemWithLocation extends FinnairBoundItem {
  departure: FinnairTravelLocation;
  arrival: FinnairTravelLocation;
}

export interface ExtendedFareFamily extends FinnairBoundFareFamily {
  benefits: FareFamily;
  fareInformation: FareInformation[];
  selected: boolean;
  disabled?: boolean;
  points?: string;
  badgeType?: FareFamilyBadgeType;
  brandName?: string;
  brandColor?: string;
  highlightedBenefits?: string[];
  isSpecialOffer?: boolean;
  isStartingFromPrice?: boolean;
}

export enum SortBy {
  DURATION = 'duration',
  PRICE = 'price',
  ARRIVAL = 'arrival',
  DEPARTURE = 'departure',
  BEST = 'best',
}

export enum FareFamilyBadgeType {
  NEW = 'NEW',
  POPULAR = 'POPULAR',
  CMS = 'CMS',
}

export interface DimensionsAndDetails {
  extendedFareFamilies: ExtendedFareFamily[];
  cabinClass: string;
  itineraries?: FinnairItineraryItemFlight[][];
}
